export const forbiddenSlug = ['office', 'driver', 'admin', 'customer', 'dashboard', 'jobs', 'inventory', 'chat', 'settings', 'tenants'];